import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_13: FaireProductEntity = {
  token: "sweet-wink-13",
  type: "product",
  name: "Howdy Patch Short Sleeve T-Shirt - Western Apparel - Fall",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/03c9a1ba9770651c6b5dc0259215d6f73483bff607edd003d89511762494003d.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1079,1079,x0,y0,safe&width=720",
  priceDollars: 14,
  msrpDollars: 28,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
